import { useEffect } from 'react';

type WingKey = 'main' | 'north' | 'east' | 'south' | 'west';

interface NavigationMapProps {
  currentSection: 'gallery' | 'wing';
  currentWing: WingKey | null;
  onNavigate: () => void;
  onNavigateToWing: (wing: WingKey | null) => void;
  onReturnToMainGallery: () => void;
}

export default function NavigationMap({
  currentSection,
  currentWing,
  onNavigate,
  onNavigateToWing,
  onReturnToMainGallery,
}: NavigationMapProps) {

  const wingPositions: Record<WingKey, { x: number; y: number; label: string }> = {
    main: { x: 200, y: 200, label: 'Main Gallery' },
    north: { x: 200, y: 80, label: 'Gallery 1' },
    east: { x: 320, y: 200, label: 'Gallery 2' },
    south: { x: 200, y: 320, label: 'Gallery 3' },
    west: { x: 80, y: 200, label: 'Gallery 4' },
  };

  const getCurrentPosition = () => {
    if (currentSection === 'wing' && currentWing) {
      return wingPositions[currentWing];
    }
    return wingPositions.main;
  };

  const currentPos = getCurrentPosition();

  return (
    <>
      {/* Breadcrumb Trail */}
      {currentSection === 'wing' && currentWing && (
        <div className="fixed top-8 left-1/2 -translate-x-1/2 z-40 flex items-center gap-2 bg-white px-6 py-3 border border-neutral-200 text-neutral-900 text-sm font-light">
          <button
            onClick={onNavigate}
            className="hover:text-black transition-colors cursor-pointer whitespace-nowrap"
          >
            Entrance
          </button>
          <i className="ri-arrow-right-s-line text-neutral-400"></i>
          <button
            onClick={onReturnToMainGallery}
            className="hover:text-black transition-colors cursor-pointer whitespace-nowrap"
          >
            Main Gallery
          </button>
          <i className="ri-arrow-right-s-line text-neutral-400"></i>
          <span className="text-black whitespace-nowrap">{wingPositions[currentWing].label}</span>
        </div>
      )}
    </>
  );
}